import React from "react";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const ChangeLang = ({label = true,color = 'dark'})=>{
	const { t } = useTranslation('common');

	const changeLanguage = (lng) => {
		i18next.changeLanguage(lng);
		if(typeof window !== "undefined") window.localStorage.setItem('lang',lng)
	}
	return(
		<div className='change-lang-wrap'>
			{label && <label htmlFor='change-lang' className={color}>{t('language')}</label>}
			<select id='change-lang' name='change-lang' key={Math.round(Math.random() * 10000)} defaultValue={i18next.language} onChange={(e) => {
				const value = e.target.value;
				changeLanguage(value)
			}}>
				<option value={'fa'}>{t('farsi')}</option>
				<option value={'en'}>{t('english')}</option>
				<option value={'ru'}>{t('russia')}</option>
			</select>
		</div>
	)
}

export default ChangeLang;